import React, { useEffect, useState } from "react";
import {
    useTable,
    useGlobalFilter,
    usePagination,
    useSortBy,
} from "react-table";
import { useLocation } from "react-router-dom";
import { decrypt } from "../../../utils/encodingdecoding";
import { arjunMerchantId } from "../../../utils";

const Paginated = ({ data, originalData, setFilteredData, columns, templateList, fetch, qrCount, selectedTemplate, setSelectedTemplate, selectedBatch, setSelectedBatch }) => {
    const [selectPage, setSelectPage] = useState();
    const [selectedPageIndex, setSelectedPageIndex] = useState(1);
    const [pageArray, setPageArray] = useState();
    const [searchText, setSearchText] = useState("");
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        state,
        page,
        setPageSize,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                hiddenColumns: ["searchText"],
                pageSize: 50
            },
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );
    const location = useLocation()
    const { pageSize } = state;


    useEffect(() => {
        return () => {
            localStorage.setItem("QRPageIndex", JSON.stringify(1));
        }
    }, [])

    useEffect(() => {
        if (qrCount) {
            let tempqrCount = qrCount / 50;
            let temp = Math.ceil(tempqrCount);
            setSelectPage(temp);
        } else {
            setSelectPage(0);
        }
    }, [qrCount]);

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("QRPageIndex"));
        if (tempPageIndex !== 1) {
            // fetch();
        }
    }, []); // eslint-disable-line

    useEffect(() => {
        const temp = Array.from({ length: selectPage }, (_, index) => index + 1);
        setPageArray(temp);
    }, [selectPage]);

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("QRPageIndex"));
        tempPageIndex ? setSelectedPageIndex(tempPageIndex) : setSelectedPageIndex(1);
    }, []);

    const handlePageIndex = (event) => {
        if (event.target.value !== "") {
            const number = Number(event.target.value);
            setSelectedPageIndex(number);
            localStorage.setItem("QRPageIndex", JSON.stringify(number));
            fetch(number, 50, selectedTemplate, selectedBatch);
        }
    };

    const handleNext = () => {
        if (selectedPageIndex < pageArray?.length) {
            setSelectedPageIndex(selectedPageIndex + 1);
            localStorage.setItem("QRPageIndex", JSON.stringify(selectedPageIndex + 1));
            fetch(selectedPageIndex + 1, 50, selectedTemplate, selectedBatch);
        }
    };

    const handlePrevious = () => {
        if (selectedPageIndex > 1) {
            setSelectedPageIndex(selectedPageIndex - 1);
            localStorage.setItem("QRPageIndex", JSON.stringify(selectedPageIndex - 1));
            fetch(selectedPageIndex - 1, 50, selectedTemplate, selectedBatch);
        }
    };
    const handleTemplateFilter = async (e) => {
        const value = e.target.value;
        setSelectedPageIndex(1);
        setSearchText("");
        setSelectedBatch("")
        setFilteredData(originalData);
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        setSelectedTemplate(value);
    };

    const handleBatchFilter = async (e) => {
        const value = e.target.value;
        setSelectedPageIndex(1);
        setSearchText("");
        setSelectedTemplate("");
        setFilteredData(originalData);
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        setSelectedBatch(value)
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        setSelectedPageIndex(1);
        localStorage.setItem("QRPageIndex", JSON.stringify(1));

        if (!value) {
            setFilteredData(originalData);
            return;
        }

        const filtered = originalData.filter((item) =>
            item.code?.toString().toLowerCase().includes(value.toLowerCase())
        );

        setFilteredData(filtered);
    };


    return (
        <div className="customTable">
            <div className="customTable__header">
                <div className="customTable__left">
                    <div className="customTable__showingRecords">
                        <div className="form-group">
                            <label>Show Records:</label>
                            <select
                                className="form-control selectArrow"
                                value={pageSize}
                                onChange={(e) => setPageSize(Number(e.target.value))}
                            >
                                {[10, 25, 50].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className=" d-flex gap-2 ">
                    {location.pathname.includes("qrcode-list") && (
                        <>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search QR Code"
                                value={searchText}
                                onChange={handleSearch}
                                style={{ width: "140px" }}
                            />
                            {decrypt(localStorage.getItem("Id")) === arjunMerchantId ? <select
                                className="form-control selectArrow"
                                value={selectedBatch}
                                onChange={handleBatchFilter}
                                style={{ width: "140px" }}
                            >
                                <option value="">Select Batch No</option>
                                {templateList?.map((tpl, index) => (
                                    <option key={index} value={tpl.batchNo}>
                                        {tpl.batchNo}
                                    </option>
                                ))}
                            </select> : <></>}

                            <select
                                className="form-control selectArrow"
                                value={selectedTemplate}
                                onChange={handleTemplateFilter}
                            >
                                <option value="">Select</option>
                                {templateList?.map((tpl, index) => (
                                    <option key={index} value={tpl.value}>
                                        {tpl.label}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}
                </div>

            </div>
            <div className="customTable__body">
                <div className="table-responsive">
                    {page?.length ? (
                        <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {page.map((row, rowIndex) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()} key={rowIndex}>
                                            {row.cells.map((cell) => {
                                                return <td {...cell.getCellProps()}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : (
                        <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={9} style={{ textAlign: "center", display: "table-cell", textTransform: "Capitalize" }}>
                                        No data found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
            <div className="customTable__footer">
                <div className="customTable__left">
                    <div className="customTable__totalTransactions">
                        <p>
                            Total Records: <span>{data?.length}</span>
                        </p>
                    </div>
                </div>
                <div className="customTable__right">
                    <div className="customTable__top">
                        <div className="customTable__totalPages">
                            {pageArray && (
                                <p>
                                    Page
                                    <select className="form-control selectArrow" value={selectedPageIndex} onChange={handlePageIndex}>
                                        {pageArray.length ? (
                                            pageArray.map((value) => (
                                                <option key={value} value={value}>
                                                    {value}
                                                </option>
                                            ))
                                        ) : (
                                            <option key={1} value={1}>
                                                {1}
                                            </option>
                                        )}
                                    </select>
                                    of{pageArray?.length ? (
                                        <span>{pageArray?.length}</span>) : <span>{1}</span>}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="customTable__bottom">
                        <div className="customTable__buttons">
                            <span className="btn btn-outline-primary" onClick={() => handlePrevious()} disabled={selectedPageIndex > 1 ? false : true}>
                                {"Previous"}
                            </span>
                            <span className="btn btn-outline-primary" onClick={handleNext} disabled={pageArray?.length > 0 ? (selectedPageIndex === pageArray?.length ? true : false) : true}>
                                {"Next"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Paginated;
